export const balansSort = (array) => {
    array.sort()
    let dot = []
    let text = []
    
    
    array.forEach(element => {
        if(element.indexOf('.') > -1 || element === "Fake OOH")
            dot.push(element)
        else 
            text.push(element)    
    });

    
    
    return [...dot,...text]
    
}